/**
 * Example trip descriptions for the homepage AI search "Try:" chips. A mix of
 * party sizes, places, rig types, logistics and trip feel, so the chips show
 * the range of things the search understands (including the qualitative cues
 * the extractor maps to vibes and tags: cozy, first RV trip, remote work...).
 * Dates are relative so the prompts never go stale.
 */
export const EXAMPLE_PROMPTS = [
  'Solo trip to Nashville the last weekend in June',
  'Family of 5 and a dog, Big Bend over spring break',
  'A trailer delivered to a lake campsite near Austin for 4 people',
  'Fly into Denver, 10 days of national parks',
  'Cozy camper van for a romantic weekend near Asheville',
  'Our first RV trip with two kids, somewhere easy to drive near Atlanta',
  'Glamping setup delivered to a campground in Sedona for a week',
  'Off-grid 4x4 van for boondocking around Moab',
  'Luxury motorhome for a tailgate in Austin this fall',
  'A van I can work remotely from for a month in Colorado',
  'Pet-friendly Class C for a Yellowstone road trip in August',
  'Something small and easy to tow with my SUV, near Portland',
  'Winter-ready camper for a ski trip to Tahoe',
  'Vintage Airstream for a weekend in Joshua Tree',
  'Bunkhouse trailer for 8 people near the Outer Banks',
  'Festival camping at Coachella, delivered and set up',
  'Pacific Coast Highway road trip for two, one way to LA',
  'Cheap campervan for a long weekend in the Smokies',
  'Motorhome that sleeps 6 for Thanksgiving with the grandparents',
  'Fall colors in Vermont, just the two of us',
  'Beach camping on the Gulf Coast with my dog',
  'Grand Canyon and Zion loop from Las Vegas, family of 4',
  'Instant-book camper van near Seattle this weekend',
  'Toy hauler for dirt bikes in the desert outside Phoenix',
  'Anniversary trip to Napa in a nice, quiet camper',
  'Spring break at Lake Powell for 6 college friends',
  'Fly into Anchorage, two weeks exploring Alaska',
  'Teardrop trailer for a solo camping weekend near Minneapolis',
  'Stargazing in Big Sky country, four nights in late July',
  'Something with a full kitchen for a week in the Upper Peninsula',
] as const;

/**
 * Returns `count` distinct prompts in random order (Fisher–Yates).
 *
 * @param count - How many prompts to return; capped at the pool size.
 * @param random - Random source in [0, 1); injectable for tests.
 */
export function pickExamplePrompts(count: number, random: () => number = Math.random): string[] {
  const pool: string[] = [...EXAMPLE_PROMPTS];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [pool[i], pool[j]] = [pool[j] as string, pool[i] as string];
  }
  return pool.slice(0, Math.max(0, Math.min(count, pool.length)));
}
